document.addEventListener('DOMContentLoaded', function() {
  // Add an event listener for click events on the document
  document.addEventListener('click', function(event) {
    // Check if the clicked element or its parent is an anchor (a) with href containing '#chat'
    var chatLink = event.target.closest('a[href*="#chat"]');
    
    if (chatLink) {
      // Log a message when a chat link or its child is clicked
      // console.log('Chat link or child clicked:', chatLink.href);
      GorgiasChat.open();

      // Prevent the default behavior of the link (preventing the page from scrolling)
      event.preventDefault();
    }
  });
});
